import { PostIdentityApiResponse } from 'core_main/api/identity/types';
import { LoginCallbackResponse } from './types';

export const createLoginCallbackResponse = (
  response: PostIdentityApiResponse,
): LoginCallbackResponse => {
  const { verified, email, externalId } = response.data.attributes;
  const customerId = response.data.relationships.customer.data.id;

  return {
    identified: verified,
    email,
    externalId,
    customerId,
  };
};
